import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext'
import { analyzeCsvLog } from '../services/analysisService';
import { CsvAnalysisData } from '../models/LogAnalysis';
import { useCustomer } from '../contexts/CustomerContext';
import CsvInput from '../components/analysis/CsvInput';
import CsvAnalysisResultDisplay from '../components/analysis/CsvAnalysisResult';
import '../components/dstack/Dstack2.css'; // Reusing DstackPage layout styles
import '../components/analysis/CsvAnalysis.css'; // Specific styles


const CsvAnalysisPage: React.FC = () => {
  const { user: currentUser } = useAuth();
  const [analysisState, setAnalysisState] = useState<CsvAnalysisData>({
    result: null,
    error: null,
    isLoading: false,
  });
  const { selectedApiKey} = useCustomer();

  const handleAnalyze = async (csvData: string) => {
    if (!currentUser) {
      setAnalysisState({
        result: null,
        error: 'User not authenticated. Please sign in.',
        isLoading: false,
      });
      return;
    }

    setAnalysisState({ result: null, error: null, isLoading: true });
    try {
      console.log( `selectedApiKey: ${selectedApiKey} and using that to call analyzeCsvLog`)
      const resultData = await analyzeCsvLog(selectedApiKey, csvData);
      setAnalysisState({ result: resultData, error: null, isLoading: false });
    } catch (err: any) {
      setAnalysisState({
        result: null,
        error: err.message || 'Failed to analyze CSV data.',
        isLoading: false,
      });
    }
  };

  return (
    <div className="dstack2-container csv-analysis-page-container">
      <div className="dstack-column dstack-input-column">
        <CsvInput onAnalyze={handleAnalyze} isLoading={analysisState.isLoading} />
      </div>
      {/* <div className="dstack-column dstack-output-column"> */}
      <div className="output-section">
        <CsvAnalysisResultDisplay
          analysisData={analysisState.result}
          error={analysisState.error}
          isLoading={analysisState.isLoading}
        />
      </div>
    </div>
  );
};

export default CsvAnalysisPage;